import { Fragment } from "react"
import { Transition } from "@headlessui/react"
import "../styles/LoadingSpinner.css"

const LoadingSpinner = () => {
  return (
    <Transition
      show={true}
      as={Fragment}
      enter="ease-out duration-300"
      enterFrom="opacity-0"
      enterTo="opacity-100"
      leave="ease-in duration-200"
      leaveFrom="opacity-100"
      leaveTo="opacity-0"
    >
      <div className="loading-overlay">
        <div className="spinner-wrapper">
          <div className="spinner"></div>
          <div className="pulse-border"></div>
          <div className="spinner-core"></div>
        </div>
      </div>
    </Transition>
  )
}

export default LoadingSpinner